import script from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThresholdSettingsComponent.vue?vue&type=style&index=0&id=e59d7046&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59d7046"]])

export default __exports__